import MDinput from '@/components/MDinput';
import { validatorRequire, validatorRequireNumber } from '@/utils/validators';
import Select from '@/components/DSE/Select';
import { ReasonStockCorrectionOption } from '@/utils/constants';
import CrudLinkReasonStockCorrectionDomain from './linkdomains/index';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false], // Page, tab 1, tab 2, ...
    showFormLabels: [true, false], // Tab 1, tab 2, ....
    labels: ['common.tabGeneral', 'common.domains'],
    headerTemplate: (str, form) => `
    <h3>
    ${form.description || ''}
    </h3>
    `,
    groups: [
      {
        description: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 64,
            required: true
          },
          rules: [
            {
              validator: validatorRequire
            }
          ],
          dynamicProps: form => ({
            disabled: form.reservedYN
          })
        },
        reasonStockCorrectionOption: {
          type: Select,
          defaultValue: ReasonStockCorrectionOption.ManualCorrection,
          props: {
            caption: 'reasonStockCorrection.reasonStockCorrectionOption',
            valueField: 'code',
            labelField: 'description',
            loading: vue.$store.getters['option/isLoading'],
            options: vue.$store.getters['option/loadedOptions']('reasonStockCorrection')
          },
          dynamicProps: form => ({
            disabled: form.reservedYN
          }),
          rules: [{ validator: validatorRequireNumber }]
        },
        linkedDomains: {
          type: CrudLinkReasonStockCorrectionDomain,
          props: {
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'reasonStockCorrectionID'
          }
        }
      }
    ]
  };
}

const layoutTabGeneral = {
  named: true,
  sections: [
    {
      width: 100,
      fields: ['description', 'reasonStockCorrectionOption']
    }
  ]
};
const layoutTabLinkedDomains = {
  named: true,
  sections: [
    {
      width: 100,
      fields: ['linkedDomains']
    }
  ]
};

export function getCreateLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral]
  };
}

export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral, layoutTabLinkedDomains]
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
